import { Result, backendApi } from "./backendApi";

export const VisAmericanStates: Record<string, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AR: "Arkansas",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  ME: "Maine",
  MD: "Maryland",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
};

export const VisAustralianStates: Record<string, string> = {
  ACT: "Australian Capital Territory",
  NSW: "New South Wales",
  NT: "Northern Territory",
  QLD: "Queensland",
  SA: "South Australia",
  TAS: "Tasmania",
  VIC: "Victoria",
  WA: "Western Australia",
};

export enum VisCountry {
  Netherlands = 1,
  UnitedStates = 3,
  UnitedKingdom = 4,
  Germany = 5,
  France = 6,
  Spain = 7,
  Italy = 9,
  Sweden = 12,
  Denmark = 13,
  Norway = 14,
  Finland = 15,
  Switzerland = 21,
  Australia = 24,
  Liechtenstein = 28,
  Austria = 30,
  FaroeIslands = 31,
}

export const VisCountries: Record<VisCountry, string> = {
  [VisCountry.Netherlands]: "The Netherlands",
  [VisCountry.Germany]: "Germany",
  [VisCountry.Austria]: "Austria",
  [VisCountry.UnitedKingdom]: "United Kingdom",
  [VisCountry.Denmark]: "Denmark",
  [VisCountry.Finland]: "Finland",
  [VisCountry.Norway]: "Norway",
  [VisCountry.Sweden]: "Sweden",
  [VisCountry.Switzerland]: "Switzerland",
  [VisCountry.UnitedStates]: "United States",
  [VisCountry.France]: "France",
  [VisCountry.Spain]: "Spain",
  [VisCountry.Italy]: "Italy",
  [VisCountry.Liechtenstein]: "Liechtenstein",
  [VisCountry.FaroeIslands]: "Faroe Islands",
  [VisCountry.Australia]: "Australia",
};

export const VisSwissNumberPlateColors: Record<number, string> = {
  0: "Unknown",
  1: "White",
  2: "Green",
  3: "Blue",
  4: "Yellow",
  5: "Brown",
  6: "Black",
};

export const VisFinnishVehicleTypes: Record<number, string> = {
  0: "Unspecified",
  1: "Moped",
  2: "Car",
  3: "Motorcycle",
  4: "Tractor or mobile machinery",
  5: "All terrain vehicle",
  6: "Trailer",
  7: "Transfer permit number",
  8: "Export registration",
};

export class GetNumberPlateVehiclesRequest {
  constructor(
    public country: VisCountry,
    public numberPlate: string,
    public finnishVehicleType: number | undefined,
    public swissNumberPlateColor: number | undefined,
    public usaState: string | undefined,
    public ausState: string | undefined,
  ) {}
}

export class VisNumberPlateVehicleModel {
  constructor(
    public recId: number,
    public vehicleFileNumber: string,
    public description: string,
  ) {}
}

export class GetNumberPlateVehiclesResponse {
  constructor(
    public vehicles: VisNumberPlateVehicleModel[],
    public warning: string,
  ) {}
}

export const visAPI = {
  async GetNumberPlate(
    request: GetNumberPlateVehiclesRequest,
  ): Promise<Result<GetNumberPlateVehiclesResponse>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetNumberPlateVehiclesResponse>(
        "GetNumberPlateVehicles",
        request,
      );

    if (response.ok) {
      return { ok: true, value: response.value };
    }

    return response;
  },
};
